import React from "react";

// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// local
import BehaviouralCard from "./BehaviouralCard";

const BehaviouralContainer = ({ behaviourals }) => {
  return (
    <Card sx={{ width: "100%" }}>
      <MDBox display="flex">
        <MDBox
          display="flex"
          justifyContent="center"
          alignItems="center"
          width="4rem"
          height="4rem"
          variant="gradient"
          bgColor="primary"
          color="white"
          shadow="md"
          borderRadius="xl"
          ml={3}
          mt={-2}
        >
          <Icon fontSize="medium" color="inherit">
            watch
          </Icon>
        </MDBox>
        <MDBox>
          <MDTypography variant="h6" sx={{ mt: 2, mb: 1, ml: 2 }}>
            Search Results
          </MDTypography>
        </MDBox>
      </MDBox>
      <Grid container>
        {behaviourals && behaviourals.length > 0 ? (
          behaviourals.map((ele, idx) => (
            <Grid key={ele.id ?? idx} item xs={12}>
              <MDBox p={2} pb={behaviourals.length - 1 === idx ? 2 : 0} m={0}>
                <BehaviouralCard no={`${idx + 1}.`} behavioural={ele} />
              </MDBox>
            </Grid>
          ))
        ) : (
          <Grid item xs={12}>
            <MDBox p={2}>
              <MDTypography variant="button" color="text">
                No results — search by username above.
              </MDTypography>
            </MDBox>
          </Grid>
        )}
      </Grid>
    </Card>
  );
};

export default BehaviouralContainer;
